import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-commonreq-library',
  template: `
     <button fd-button  (click)="clickEventHandler($event)" >Add to cart</button>
  `,
  styles: [
  ]
})
export class CommonreqLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  clickEventHandler(event): void {

  }

}
